<div class="grid">
    <div class="col-12">
        <div class="card">
            <form>
                <div class="formgroup">
                    <div class="flex justify-content-center mt-3" *ngIf="loading">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                    <div *ngIf="messagemVisivel" class="w-auto mb-5">
                        <p-messages
                            [(value)]="messages"
                            [enableService]="false"
                            [closable]="true"
                        ></p-messages>
                    </div>
                    <div class="p-fluid p-formgrid" *ngIf="itemServico && !loading">
                        <div class="col-12 pt-5 px-5">
                                <div class="grid card-simple">
                                    <div class="col-12 sm:col-6 md:col-4 xl:col-3">
                                        <label class="font-semibold">Descrição</label>
                                        <label class="block">
                                            {{ itemServico.descricao }}
                                        </label>
                                    </div>
                                    <div class="col-12 sm:col-6 md:col-4 xl:col-3">
                                        <label class="font-semibold">Grupo</label>
                                        <label class="block">
                                            {{ itemServico.subgrupo?.grupo?.descricao }} - {{ itemServico.subgrupo?.descricao }}
                                        </label>
                                    </div>
                                    <div class="col-12 sm:col-6 md:col-4 xl:col-3">
                                        <label class="font-semibold">Comissão</label>
                                        <label class="block">
                                            {{
                                                itemServico.comissaoVenda
                                                    ? (itemServico.comissaoVenda / 100
                                                      | percent: "1.2-2")
                                                    : "0,00%"
                                            }}
                                        </label>
                                    </div>
                                    <div class="col-12 sm:col-6 md:col-4 xl:col-3">
                                        <label class="font-semibold">Custo Total</label>
                                        <label class="block">
                                            {{custoTotal | percent: "1.2-2"}}
                                        </label>
                                    </div>
                                    
                                    
                                    <div class="col-12 sm:col-6 md:col-4 xl:col-3">
                                        <label class="font-semibold">Valor Serviço</label>
                                        <label class="block">
                                            {{ itemServico.valorVenda | currency: "BRL" }}
                                        </label>
                                    </div>
                                    
                                    
                                    <div class="col-12 sm:col-6 md:col-4 xl:col-3">
                                        <label class="font-semibold">
                                            Lucro Atual
                                        </label>
                                        <label class="block">
                                            {{ valorLucroObtidoAtual | currency: "BRL" }} |
                                            {{
                                                ((valorLucroObtidoAtual /
                                                    (itemServico.valorVenda ?? 0)) *
                                                    100) /
                                                    100 | percent: "1.2-2"
                                            }}
                                        </label>
                                    </div>


                                    <p-divider class="w-full"></p-divider>


                                    <div class="field col-12 sm:col-4">
                                        <label class="text-lg">Novo Valor</label>
                                        <p-inputNumber
                                            name="novoValorServico"
                                            ngModel
                                            mode="currency"
                                            currency="BRL"
                                            locale="pt-BR"
                                            [allowEmpty]="true"
                                            [required]="true"
                                            [(ngModel)]="novoValorServico"
                                            (onInput)="calcularLucroObtido($event.value)"
                                        ></p-inputNumber>
                                    </div>

                                    
                                    <div class="field col-12 sm:col-2">
                                        <label class="text-lg font-semibold">
                                            Lucro Obtido
                                        </label>
                                        <label
                                            class="block"
                                            *ngIf="novoValorServico > 0"
                                        >
                                            <span
                                                class="product-badge bg-green-600 admihair-text-white"
                                                *ngIf="valorLucroObtido >= valorLucroDesejado"
                                            >
                                                {{ valorLucroObtido | currency: "BRL" }}
                                            </span>
                                            <span
                                                class="product-badge bg-red-600 admihair-text-white"
                                                *ngIf="valorLucroObtido < valorLucroDesejado"
                                            >
                                                {{ valorLucroObtido | currency: "BRL" }}
                                            </span>
                                        </label>
                                        <label
                                            class="block"
                                            *ngIf="novoValorServico <= 0"
                                        >
                                            {{ valorLucroObtido | currency: "BRL" }}
                                        </label>
                                    </div>
                                    
                                    
                                </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
